export enum ACCESS_CONTROL_TYPES {
    // perfil
    ROLE_PERFIL_READ = "ROLE_PERFIL_READ",
    ROLE_CENTRAL_READ = "ROLE_CENTRAL_READ",
    ROLE_MARGIN_EDIT = "ROLE_MARGIN_EDIT",

    // dashboard
    ROLE_DASHBOARD_READ = "ROLE_DASHBOARD_READ",
    
    // painel
    ROLE_PANEL_READ = "ROLE_PANEL_READ",

    // cadastro
    ROLE_REGISTER_READ = "ROLE_REGISTER_READ",
    ROLE_USERS_READ = "ROLE_USERS_READ",
    ROLE_CUSTOMERS_READ = "ROLE_CUSTOMERS_READ",
    ROLE_TECHNICIANS_READ = "ROLE_TECHNICIANS_READ",

    // operacional
    ROLE_OPERATIONAL_READ = "ROLE_OPERATIONAL_READ",
    ROLE_TRACKERS_READ = "ROLE_TRACKERS_READ",
    ROLE_CHIPS_READ = "ROLE_CHIPS_READ",
    ROLE_VEHICLES_READ = "ROLE_VEHICLES_READ",
    ROLE_OPERATIONAL_REPORTS_READ = "ROLE_OPERATIONAL_REPORTS_READ",

    // monitoramento
    ROLE_MONITORING_READ = "ROLE_MONITORING_READ",
    ROLE_MAP_READ = "ROLE_MAP_READ",
    ROLE_MONITORING_REPORTS_READ = "ROLE_MONITORING_REPORTS_READ",
    
    // notificações
    ROLE_NOTIFICATIONS_READ = "ROLE_NOTIFICATIONS_READ",
    ROLE_NOTIFICATIONS_MANAGE = "ROLE_NOTIFICATIONS_MANAGE",
    ROLE_DASHBOARD_NOTIFICATIONS_READ = "ROLE_DASHBOARD_NOTIFICATIONS_READ",

    // instalação
    ROLE_INSTALLATION_READ = "ROLE_INSTALLATION_READ",
    ROLE_SERVICE_ORDER_READ = "ROLE_SERVICE_ORDER_READ",

    // financeiro
    ROLE_FINANCIAL_MENU_READ = "ROLE_FINANCIAL_MENU_READ",
    ROLE_CHARGES_READ = "ROLE_CHARGES_READ",
    ROLE_EXTRACT_READ = "ROLE_EXTRACT_READ",
    ROLE_PRODUCTS_READ = "ROLE_PRODUCTS_READ",
    ROLE_NEGATIVES_READ = "ROLE_NEGATIVES_READ",

    // escritório
    ROLE_DESK_READ = "ROLE_DESK_READ",

    // documentos do sistema
    ROLE_SYSTEM_DOCS_READ = "ROLE_SYSTEM_DOCS_READ",
    ROLE_SYSTEM_DOCS_MANAGE = "ROLE_SYSTEM_DOCS_MANAGE",

    // apólices
    ROLE_POLICIES_READ = "ROLE_POLICIES_READ",
    ROLE_POLICIES_MANAGE = "ROLE_POLICIES_MANAGE",

    // contratos
    ROLE_CONTRACTS_READ = "ROLE_CONTRACTS_READ",
    ROLE_CONTRACTS_MANAGE = "ROLE_CONTRACTS_MANAGE",
};